import React from "react";

// Slow editorial marquee — signature typographic band.
const WORDS = [
  "Marca blanca",
  "I+D propio",
  "GMP",
  "Registro FDA",
  "Proteínas",
  "Creatina",
  "Aminoácidos",
  "Pre-entrenos",
  "Logística propia",
];

export default function Marquee() {
  const items = [...WORDS, ...WORDS];
  return (
    <section className="relative bg-white border-y border-slate-200 py-5 md:py-7 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="relative overflow-hidden">
          <div className="marquee-track-slow flex gap-8 whitespace-nowrap w-max items-center opacity-80">
            {items.map((w, i) => (
              <span key={`${w}-${i}`} className="font-display text-[0.63rem] md:text-[1.05rem] font-extrabold uppercase tracking-tighter text-[#0A1628]">
                {w}
              </span>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-12 md:w-24 bg-gradient-to-r from-white to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-12 md:w-24 bg-gradient-to-l from-white to-transparent" />
        </div>
      </div>
    </section>
  );
}
